import React from 'react'
import { browserHistory } from 'react-router'

import BillVendorView from '../../../components/Payables/Bill/BillVendorView'

export default class VendorBillTemplate extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUpdate(nextProps, nextState) {

    }

    render(){
        return (
            <div>
                <BillVendorView />
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/VendorView/VendorBill/VendorBill.jsx